import { motion } from "framer-motion";

interface LogoItem {
  url: string;
  alt: string;
}

interface LogoBarProps {
  logos?: LogoItem[];
}

export function LogoBar({ logos = [] }: LogoBarProps) {
  if (logos.length === 0) return null;

  return (
    <section className="py-6 border-b border-border">
      <div className="container-padding mx-auto">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          className="text-xs uppercase tracking-widest text-muted-foreground text-center mb-6"
        >
          Trusted by industry leaders
        </motion.p>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-4 sm:gap-x-8 md:gap-x-12 lg:gap-x-16">
          {logos.map((logo, i) => (
            <motion.img
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 0.7, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              whileHover={{ opacity: 1, y: -2, scale: 1.05 }}
              src={logo.url}
              alt={logo.alt || "Partner logo"}
              className="h-8 md:h-10 w-auto object-contain transition-all duration-200"
              loading="lazy"
              decoding="async"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
